import { format, isValid, parseISO } from "date-fns";

/**
 * Formats a date value into a relative string in Spanish.
 * Accepts Date instances or values compatible with the Date constructor.
 *
 * @param {Date|string|number} value
 * @returns {string}
 */
export const formatRelativeDate = (value) => {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const now = new Date();
  const diff = now - date;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (hours < 1) return "Hace unos minutos";
  if (hours < 24) return `Hace ${hours}h`;
  if (days === 1) return "Ayer";
  if (days < 7) return `Hace ${days} días`;

  return date.toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
  });
};

const normalizeDateValue = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value === "string") {
    const parsedIsoDate = parseISO(value);
    if (isValid(parsedIsoDate)) {
      return parsedIsoDate;
    }
  }

  const parsedDate = new Date(value);
  return isValid(parsedDate) ? parsedDate : null;
};

export const formatFilterDateLabel = (value) => {
  if (!value) return "";

  const parsedDate = normalizeDateValue(value);
  return parsedDate ? format(parsedDate, "dd/MM/yyyy") : value;
};

export const buildDateRangeChipLabel = ({
  label,
  start,
  end,
}) => {
  const startLabel = formatFilterDateLabel(start);
  const endLabel = formatFilterDateLabel(end);

  if (startLabel && endLabel) {
    return `${label}: ${startLabel} - ${endLabel}`;
  }

  if (startLabel) {
    return `${label} desde: ${startLabel}`;
  }

  if (endLabel) {
    return `${label} hasta: ${endLabel}`;
  }

  return "";
};

/**
 * react-day-picker `range` mode extends the current range on each click; here
 * a click on a closed range always starts a new one, and the next click closes it.
 */
export const nextRangeOnDayClick = (range, day) => {
  if (range?.from && !range.to) {
    return range.from <= day ? { from: range.from, to: day } : { from: day, to: range.from };
  }
  return { from: day, to: undefined };
};
